import { memo } from "react";

const ActionSee = (props: any) => (
  <svg {...props} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_5329_1063)">
      <path
        d="M1.16669 8.00008C1.16669 8.00008 3.83335 2.66675 8.50002 2.66675C13.1667 2.66675 15.8334 8.00008 15.8334 8.00008C15.8334 8.00008 13.1667 13.3334 8.50002 13.3334C3.83335 13.3334 1.16669 8.00008 1.16669 8.00008Z"
        stroke="currentColor"
        strokeWidth="1.45494"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 10C9.60457 10 10.5 9.10457 10.5 8C10.5 6.89543 9.60457 6 8.5 6C7.39543 6 6.5 6.89543 6.5 8C6.5 9.10457 7.39543 10 8.5 10Z"
        stroke="currentColor"
        strokeWidth="1.45494"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5329_1063">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default memo(ActionSee);
